/**
 * Parses a stack trace string into structured frames.
 * @util
 *
 * @param stack - The stack trace string to parse
 * @returns An array of parsed stack frames
 *
 * @__NO_SIDE_EFFECTS__
 */
export function parseStackTrace(stack) {
    return stack
        .split('\n')
        .filter(line => line.trim())
        .map(line => {
        const match = line.match(/^\s*at\s+(.+?)\s+\((.+?):(\d+):(\d+)\)/);
        if (match) {
            const filePath = match[2];
            return {
                type: 'function',
                name: match[1],
                filePath: `${filePath}:${match[3]}:${match[4]}`,
            };
        }
        const simpleMatch = line.match(/^\s*at\s+(.+)/);
        if (simpleMatch) {
            return {
                type: 'simple',
                text: simpleMatch[1],
            };
        }
        return {
            type: 'raw',
            text: line,
        };
    });
}
//# sourceMappingURL=parseStackTrace.js.map